import { useApi } from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';
import { rithumAgentApiRef } from './RithumAgentApi';
import { normalizeAgentDescriptors } from './normalizeAgentDescriptors';
import { FALLBACK_OPTIONS } from './constants';
import type { RithumAgentOptionsResponse } from './types';

export function useRithumAgentOptions(enabled = true): {
  options: RithumAgentOptionsResponse;
  loading: boolean;
} {
  const rithumAgentApi = useApi(rithumAgentApiRef);
  const [options, setOptions] =
    useState<RithumAgentOptionsResponse>(FALLBACK_OPTIONS);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const opts = await rithumAgentApi.getOptions();
        const agents = normalizeAgentDescriptors(opts.agents);
        if (!cancelled && agents.length) {
          setOptions({
            agents,
            modelsByProvider:
              opts.modelsByProvider ?? FALLBACK_OPTIONS.modelsByProvider,
            agentNames: opts.agentNames?.length
              ? opts.agentNames
              : FALLBACK_OPTIONS.agentNames,
          });
        }
      } catch {
        /* keep fallbacks */
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [rithumAgentApi, enabled]);

  return { options, loading };
}
